// constants
import { commonImage } from 'constants/images';

// libraries
import styled from 'styled-components';

interface StyledBasicButtonProps {
  width?: string | number;
  bgColor?: string;
}

export const StyledBasicButton = styled.div<StyledBasicButtonProps>`
  .MuiButtonBase-root {
    width: ${(props) => (props.width ? props.width : 'auto')};
    height: 40px;
    box-shadow: none;
    border-radius: 6px;
    box-shadow: 0px 4px 19px 0px rgba(0, 0, 0, 0.1);

    &:hover {
      box-shadow: 0px 4px 19px 0px #0000001a;
    }

    &.modalCloseButton {
      background-image: url(${commonImage.modalClose});
      background-size: contain;
      background-repeat: no-repeat;
      transform: translateY(8px);
      margin-left: auto;
      width: 24px !important;
      border: none !important;
      box-shadow: none !important;
      min-width: 24px !important;
    }

    &.iconButton {
      padding: 0;
      width: 24px !important;
      min-width: 24px !important;
      border: none !important;
      box-shadow: none !important;
    }
  }

  .MuiButton-text {
    color: var(--color-primary-blue);
  }

  .MuiButton-contained {
    background: ${({ bgColor }) => (bgColor ? bgColor : 'var(--color-primary-blue)')} !important;
  }

  .MuiButton-outlined {
    border: 1px solid var(--color-primary-blue);
    background: var(--color-white) !important;
    color: var(--color-primary-blue);
  }
`;
